// extracted by mini-css-extract-plugin
export default {"list":"BookDetailList_list__2dTa-"};